import * as React from 'react'

import { InfoCard } from 'components/InfoCard'
import { useGATrackEvent } from 'app/Homepage/hooks/useGATrackEvent'

import ImgPancasilaStudentProfile from 'assets/images/curriculum-info/pancasila-student-profile.svg'
import ImgBasicPrinciple from 'assets/images/curriculum-info/basic-principle.svg'
import ImgCPATP from 'assets/images/curriculum-info/cp-atp.svg'

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

interface CurriculumInfoListProps {
  openInNewTab?: boolean
}
const CurriculumInfoList = ({ openInNewTab }: CurriculumInfoListProps) => {
  const { GATrackEventHomePage } = useGATrackEvent()

  return (
    <>
      <InfoCard
        href={`${baseUrl}/kurikulum/perkenalan`}
        onClick={() =>
          GATrackEventHomePage({
            activityType: 'CLICK_PARADIGMA_BASIC_PRINCIPLES',
            eventTrigger: 'HOME_PAGE',
            screenName: 'WEB_HOMEPAGE',
          })
        }
        className="mb-3"
        title="Prinsip Dasar"
        subtitle="Kenali prinsip dan konsep pembelajaran paradigma baru yang berpusat pada murid."
        asNewTab={openInNewTab}
      >
        <ImgBasicPrinciple />
      </InfoCard>
      <InfoCard
        href={`${baseUrl}/kurikulum/referensi-penerapan/profil-pelajar-pancasila`}
        className="mb-3"
        title="Profil Pelajar Pancasila"
        subtitle="Temukan penjelasan dimensi & elemen profil pelajar pancasila sesuai Fase Anda."
        asNewTab={openInNewTab}
      >
        <ImgPancasilaStudentProfile />
      </InfoCard>
      <InfoCard
        href={`${baseUrl}/kurikulum/referensi-penerapan/capaian-pembelajaran`}
        className="mb-3"
        title="CP & ATP"
        subtitle="Temukan Capaian Pembelajaran (CP) & contoh Alur Tujuan Pembelajaran (ATP) sesuai Mata Pelajaran Anda."
        asNewTab={openInNewTab}
      >
        <ImgCPATP />
      </InfoCard>
    </>
  )
}

export default CurriculumInfoList
